"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decompress = exports.decodeAndDecompress = void 0;
const pako_1 = require("pako");
const decodeAndDecompress = (encodedString) => {
    // Decode the base64 string back into a byte array
    const decodedByteArray = new Uint8Array(atob(encodedString)
        .split('')
        .map((char) => char.charCodeAt(0)));
    // Decompress the byte array using pako
    const decompressedString = (0, pako_1.inflate)(decodedByteArray, { to: 'string' });
    return JSON.parse(decompressedString);
};
exports.decodeAndDecompress = decodeAndDecompress;
const decompress = (buffer) => {
    if (buffer === null)
        return;
    let uint8Array;
    if (typeof buffer === 'string')
        return JSON.parse(buffer);
    else
        uint8Array = new Uint8Array(buffer);
    // Decompress the data using ungzip
    const decompressedData = (0, pako_1.ungzip)(uint8Array, { to: 'string' });
    // Return the parsed JSON
    try {
        return JSON.parse(decompressedData);
    }
    catch (error) {
        // For now Ping message is the only one that isn't in JSON format
        return decompressedData;
    }
};
exports.decompress = decompress;
//# sourceMappingURL=decompress.js.map